import { render, staticRenderFns } from "./Collapsible.vue?vue&type=template&id=5e81f690"
import script from "./Collapsible.vue?vue&type=script&lang=ts"
export * from "./Collapsible.vue?vue&type=script&lang=ts"
import style0 from "./Collapsible.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TabItem: require('/app/components/base/TabItem/TabItem.vue').default,LinkComponent: require('/app/components/base/LinkComponent/LinkComponent.vue').default,InfowindowComponent: require('/app/components/base/InfowindowComponent/InfowindowComponent.vue').default,RichText: require('/app/components/base/RichText/RichText.vue').default})
